import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrandingProposalTips } from './components/BrandingProposalTips';
import { Header } from './components/Header';

function Post4() {
  return (
    <div className="App">
      <Header />
      <BrandingProposalTips />
    </div>
  );
}

export default Post4;